import { EducationalOffer } from '../models/educational-offer.model';

export const EDUCATIONAL_OFFERS: EducationalOffer[] = [
  {
    icon: '🎓',
    title: 'Basic Student',
    price: '89',
    currency: 'DT',
    period: '/month',
    features: [
      'Access to core subjects',
      'Interactive digital lessons',
      'Basic progress tracking',
      'Teacher communication',
      'Mobile app access',
      'Study materials download'
    ]
  },
  {
    icon: '🏆',
    title: 'Premium Student',
    price: '149',
    currency: 'DT',
    period: '/month',
    featured: true,
    features: [
      'All subjects + electives',
      'Live interactive classes',
      'Advanced progress analytics',
      '1-on-1 tutoring sessions',
      'Priority teacher support',
      'Exam preparation tools',
      'Achievement certificates',
      'Parent dashboard access'
    ]
  },
  {
    icon: '🔥',
    title: 'Family Package',
    price: '249',
    currency: 'DT',
    period: '/month',
    features: [
      'Up to 3 students',
      'All premium features included',
      'Family progress dashboard',
      'Sibling collaboration tools',
      'Bulk assignment management',
      'Family learning goals',
      'Multi-child scheduling',
      'Dedicated family support'
    ]
  }
];
